import React from "react";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaTwitter, FaYoutube, FaPinterest } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-gray-600 text-white py-8">
      <div className="container mx-auto px-4 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="grid grid-rows-2">
            {/* First Row: Logo and Name */}
            <div className="flex items-center space-x-1">
              <img
                src="/images/logoend.png"
                alt="GrowHome Studio Logo best interiors in hyderabad"
                className="h-10 w-auto"
              />
              <h3 className="text-l font-bold">Grow Home Studio</h3>
            </div>

            {/* Second Row: Description */}
            <p className="text-sm">
              Transforming your space <br />
              into your dream home with custom interior solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <a href="/" className="text-sm text-white hover:text-orange-500">
                  Home
                </a>
              </li>
              <li>
                <a
                  href="/about"
                  className="text-sm text-white hover:text-orange-500"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="/services"
                  className="text-sm text-white hover:text-orange-500"
                >
                  Our Services
                </a>
              </li>
              <li>
                <a
                  href="/contact"
                  className="text-sm text-white hover:text-orange-500"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <p className="text-sm">Hyderabad, India</p>
            <p className="text-sm">Phone: +91 6303619305</p>
            <p className="text-sm">Email: info.growhomestudio@gmail.com</p>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/share/1QhX89hqNP/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-110 transition-transform"
              >
                <FaFacebookF className="text-[#e9a200] w-6 h-5 pt-1" />
              </a>
              <a
                href="https://www.instagram.com/interiors_by_growhomestudio/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-110 transition-transform"
              >
                <FaInstagram className="text-[#e9a200] w-6 h-6" />
              </a>
              <a
                href="https://www.linkedin.com/in/grow-home-studio-872290343?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-110 transition-transform"
              >
                <FaLinkedinIn className="text-[#e9a200] w-6 h-6" />
              </a>
              <a
                href="https://x.com/growhomestudio?s=21"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-110 transition-transform"
              >
                <FaTwitter className="text-[#e9a200] w-6 h-6" />
              </a>
              <a
                href="https://youtube.com/@interiorsbygrowhomestudio?si=TtmwqmSRG098AbKV"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-110 transition-transform"
              >
                <FaYoutube className="text-[#e9a200] w-6 h-6" />
              </a>
              <a
                href="https://pin.it/7VAqsHQ85"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:scale-110 transition-transform"
              >
                <FaPinterest className="text-[#e9a200] w-6 h-6" />
              </a>
            </div>
          </div>
        </div>
        <div className="border-t border-white mt-8 pt-4 text-center text-sm">
          <p>
            &copy; {new Date().getFullYear()} Grow Home Studio Private Limited. All
            Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
